const backupMenu = [
  {
    title: "Dashboard",
    id: "dashboard",
    url: "/",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Dashboard")
  },
  {
    title: "Order",
    id: "order",
    url: "/order",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Order")
  },
  {
    title: "AWB Tracking",
    id: "awb-tracking",
    url: "/tracking",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Tracking")
  },
  {
    title: "Partner",
    id: "partner",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Partner"),
    submenu: [
      {
        title: "All Partners",
        url: "/partner/list"
      },
      {
        title: "User",
        url: "/partner/user"
      },
      {
        title: "Driver",
        url: "/partner/driver"
      },
      {
        title: "Dropoff Agent",
        url: "/partner/dropoff"
      }
    ]
  },
  {
    title: "Delivery",
    id: "delivery",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Delivery"),
    submenu: [
      {
        title: "Cost Mapping",
        url: "/delivery/cost-mapping"
      },
      {
        title: "Package",
        url: "/delivery/package"
      }
    ]
  },
  {
    title: "Master Data",
    id: "master-data",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Data"),
    submenu: [
      {
        title: "City",
        url: "/master-data/city"
      },
      {
        title: "Payment Method",
        url: "/master-data/payment-method"
      },
      {
        title: "Goods Category",
        url: "/master-data/goods-category"
      },
      {
        title: "Bank Code",
        url: "/master-data/bank-code"
      }
    ]
  },
  {
    title: "Pertashop",
    id: "pertashop",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/GasStation"),
    submenu: [
      {
        title: "Local Agent",
        url: "/pertashop/local-agent"
      }
    ]
  },
  {
    title: "Role",
    id: "role",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/UserSetting"),
    submenu: [
      {
        title: "Role Management",
        url: "/role/role-management"
      },
      {
        title: "Permission List",
        url: "/role/permission"
      },
      {
        title: "Role List",
        url: "/role/list"
      }
    ]
  },
  {
    title: "Admin",
    id: "admin",
    url: "/admin",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/UserSetting")
  }
]

const internalMenu = [
  {
    title: "Mitra Logistik",
    id: "partner",

    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/User"),
    active: false,
    submenu: [
      {
        title: "Mitra Logistik",
        url: "/partner"
      },
      {
        title: "Pendaftaran Mandiri",
        url: "/partner-self-registration"
      }
    ]
  },
  {
    title: "Mitra Bisnis",
    id: "merchant",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/User"),
    active: false,
    submenu: [
      {
        title: "Mitra Bisnis",
        url: "/merchant"
      },
      {
        title: "Pendaftaran Mandiri",
        url: "/self-registration"
      }
    ]
  },
  {
    title: "Pesanan",
    id: "order",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Order"),
    active: false,
    submenu: [
      {
        title: "Daftar Pesanan",
        url: "/order"
      },
      {
        title: "Instan",
        url: "/order/instant-deliveries"
      },
      {
        title: "Penyesuaian Harga",
        url: "/order/price-adjustment"
      }
    ]
  },
  {
    title: "Invoice",
    id: "invoice",
    url: "/invoice",
    icon: () => import(/* webpackChunkName: "icon" */ "@/components/Icons/Data")
  },
  {
    title: "Invoice Generator",
    id: "invoice-generator",
    active: false,
    icon: () => import(/* webpackChunkName: "icon" */ "@/components/Icons/Article"),
    submenu: [
      {
        title: "Customers",
        url: "/invoices/customers"
      },
      {
        title: "Resi",
        url: "/invoices/resi"
      },
      {
        title: "Invoices",
        url: "/invoices/invoices"
      }
    ]
  },
  {
    title: "Admin Pengguna",
    id: "admin",
    url: "/admin",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/UserSetting")
  },
  {
    title: "Role Pengguna",
    id: "role",
    url: "/user/role",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/UserSetting")
  },
  {
    title: "Kategori Barang",
    id: "goods",
    url: "/goods-category",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Goods")
  },
  {
    title: "Laporan Biaya",
    id: "reports",
    url: "/reports",
    icon: () =>
      import(/* webpackChunkName: "Icons" */ "@/components/Icons/Transaction")
  },
  {
    title: "Notifikasi",
    id: "notifikasi",
    url: "/notifikasi",
    icon: () =>
      import(/* webpackChunkName: "Icons" */ "@/components/Icons/Alert")
  },
  {
    title: "Artikel",
    id: "Article",
    url: "/article",
    icon: () =>
      import(/* webpackChunkName: "Icons" */ "@/components/Icons/Article")
  },
  {
    title: "Karir",
    id: "Career",
    url: "/career",
    icon: () =>
      import(/* webpackChunkName: "Icons" */ "@/components/Icons/User")
  },
  {
    title: "Pengaturan Web",
    id: "web",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/WebSettings"),
    active: false,
    submenu: [
      {
        title: "Logo Mitra",
        url: "/web-settings/mitra-logos"
      }
    ]
  },
  {
    title: "Promo Management",
    id: "promo",
    url: "/promo",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Discount")
  },
  {
    id: "voucher",
    title: "Voucher Management",
    url: "/voucher",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Voucher")
  },
  {
    id: "banner",
    title: "Banner Management",
    url: "/banner",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Banner")
  },
  {
    title: "Smesco",
    id: "smesco",
    icon: () => import(/* webpackChunkName: "icon" */ "@/components/Icons/User"),
    active: false,
    submenu: [
      {
        title: "Fee Setting",
        url: "/smesco/fee-setting"
      },
      {
        title: "Revenue",
        url: "/smesco/revenue"
      }
    ]
  },
  {
    title: "Request Demo",
    id: "request-demo",
    url: "/request-demo",
    icon: () => import(/* webpackChunkName: "icon" */ "@/components/Icons/Info")
  }
]

const internalCSMenu = [
  {
    title: "Pesanan",
    id: "order",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Order"),
    submenu: [
      {
        title: "Kurang Bayar",
        url: "/order/insufficient-payment"
      }
    ]
  }
]

const externalHubMenu = [
  {
    title: "Pesanan",
    id: "order",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Order"),
    submenu: [
      {
        title: "Daftar Pesanan",
        url: "/order"
      },
      {
        title: "Instan",
        url: "/order/instant-deliveries"
      }
    ]
  },
  {
    title: "Cek AWB",
    id: "awb-tracking",
    url: "/tracking",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/AwbTracking")
  }
]

const externalMenu = [
  {
    title: "Dashboard",
    id: "dashboard",
    url: "/",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Dashboard")
  },
  {
    title: "Cek AWB",
    id: "awb-tracking",
    url: "/tracking",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/AwbTracking")
  },
  {
    title: "Pesanan",
    id: "order",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Order"),
    submenu: [
      {
        title: "Daftar Pesanan",
        url: "/order"
      },
      {
        title: "Instan",
        url: "/order/instant-deliveries"
      },
      {
        title: "Permintaan Pickup",
        url: "/order/pickup"
      }
    ]
  },
  // {
  //   title: 'Armada',
  //   id: 'armada',
  //   active: false,
  //   icon: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Driver'),
  //   submenu: [
  //     {
  //       title: 'Daftar Armada',
  //       url: '/armada'
  //     },
  //     {
  //       title: 'Partner Armada',
  //       url: '/armada/partner'
  //     }
  //   ]
  // },
  // {
  //   title: 'Kurir',
  //   id: 'kurir',
  //   url: '/kurir',
  //   icon: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Courier')
  // },
  // {
  //   title: 'Partner',
  //   id: 'partner',
  //   active: false,
  //   url: '/partner',
  //   icon: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Courier')
  // },
  {
    title: "User",
    id: "user",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/User"),
    submenu: [
      {
        title: "User List",
        url: "/user"
      },
      {
        title: "User Role",
        url: "/user/role"
      }
    ]
  },
  // {
  //   title: 'Hub/Drop Point',
  //   id: 'hub',
  //   url: '/hub',
  //   icon: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Courier')
  // },
  // {
  //   title: 'Keuangan',
  //   id: 'finance',
  //   active: false,
  //   icon: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Transaction'),
  //   submenu: [
  //     {
  //       title: 'Pendapatan',
  //       url: '/finance/income'
  //     },
  //     {
  //       title: 'Penarikan',
  //       url: '/finance/withdraw'
  //     }
  //   ]
  // },
  {
    title: "Layanan",
    id: "package",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Price"),
    submenu: [
      {
        title: "Layanan",
        url: "/package"
      },
      {
        title: "Cost Mapping",
        url: "/package/cost-mapping"
      }
    ]
  }
  // {
  //   title: 'Master Data',
  //   id: 'master-data',
  //   active: false,
  //   icon: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Data'),
  //   submenu: [
  //     {
  //       title: 'City',
  //       url: '/master-data/city'
  //     },
  //     {
  //       title: 'Payment Method',
  //       url: '/master-data/payment-method'
  //     },
  //     {
  //       title: 'Goods Category',
  //       url: '/master-data/goods-category'
  //     },
  //     {
  //       title: 'Bank Code',
  //       url: '/master-data/bank-code'
  //     }
  //   ]
  // },
  // {
  //   title: 'Pertashop',
  //   id: 'pertashop',
  //   active: false,
  //   icon: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/GasStation'),
  //   submenu: [
  //     {
  //       title: 'Local Agent',
  //       url: '/pertashop/local-agent'
  //     }
  //   ]
  // },
  // {
  //   title: 'Role',
  //   id: 'role',
  //   active: false,
  //   icon: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/UserSetting'),
  //   submenu: [
  //     {
  //       title: 'Role Management',
  //       url: '/role/role-management'
  //     },
  //     {
  //       title: 'Permission List',
  //       url: '/role/permission'
  //     },
  //     {
  //       title: 'Role List',
  //       url: '/role/list'
  //     }
  //   ]
  // },
  // {
  //   title: 'Admin',
  //   id: 'admin',
  //   url: '/admin',
  //   icon: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/UserSetting')
  // }
]

const externalDSNSMenu = [
  {
    title: "Dashboard",
    id: "dashboard",
    url: "/",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Dashboard")
  },
  {
    title: "Cek AWB",
    id: "awb-tracking",
    url: "/tracking",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/AwbTracking")
  },
  {
    title: "Pesanan",
    id: "order",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Order"),
    submenu: [
      {
        title: "Daftar Pesanan",
        url: "/order"
      },
      {
        title: "Instan",
        url: "/order/instant-deliveries"
      },
      {
        title: "Permintaan Pickup",
        url: "/order/pickup"
      }
    ]
  },
  {
    title: "Kurir",
    id: "kurir",
    url: "/kurir",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Courier")
  },
  {
    title: "User",
    id: "user",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/User"),
    submenu: [
      {
        title: "User List",
        url: "/user"
      },
      {
        title: "User Role",
        url: "/user/role"
      }
    ]
  },
  {
    title: "Layanan",
    id: "package",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Price"),
    submenu: [
      {
        title: "Layanan",
        url: "/package"
      },
      {
        title: "Cost Mapping",
        url: "/package/cost-mapping"
      }
    ]
  }
]

const externalDSWSMenu = [
  {
    title: "Dashboard",
    id: "dashboard",
    url: "/",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Dashboard")
  },
  {
    title: "Cek AWB",
    id: "awb-tracking",
    url: "/tracking",
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/AwbTracking")
  },
  {
    title: "Pesanan",
    id: "order",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Order"),
    submenu: [
      {
        title: "Daftar Pesanan",
        url: "/order"
      },
      {
        title: "Instan",
        url: "/order/instant-deliveries"
      }
    ]
  },
  {
    title: "User",
    id: "user",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/User"),
    submenu: [
      {
        title: "User List",
        url: "/user"
      },
      {
        title: "User Role",
        url: "/user/role"
      }
    ]
  },
  {
    title: "Layanan",
    id: "package",
    active: false,
    icon: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Price"),
    submenu: [
      {
        title: "Layanan",
        url: "/package"
      },
      {
        title: "Cost Mapping",
        url: "/package/cost-mapping"
      }
    ]
  }
]

export {
  externalMenu,
  externalDSNSMenu,
  externalDSWSMenu,
  internalMenu,
  internalCSMenu,
  externalHubMenu
}
